import { createContext, PropsWithChildren } from 'react';

import { RailEuropeTrainQueryParam } from '~types/queryParam';
import getValidQueryString from '~utils/queryStrings/getValidQueryString';

// TODO: 교통수단 추가 시 페이지에 맞게 타입 추가
type QueryParam = RailEuropeTrainQueryParam;

interface Props {
  queries?: QueryParam;
}

export const ServerSideQueryContext = createContext(getValidQueryString());

function ServerSideQueryProvider({ queries, children }: PropsWithChildren<Props>) {
  return (
    <ServerSideQueryContext.Provider value={queries ?? getValidQueryString()}>
      {children}
    </ServerSideQueryContext.Provider>
  );
}

export default ServerSideQueryProvider;
